module.exports = "/assets/data/efa6e05ce0d766131892e40008de4a63-SK13.data.json";